<template>
  <div>
    <el-tabs v-model="active" type="border-card">
      <el-tab-pane label="待发运单列表" name="A" lazy>
        <assign-table />
      </el-tab-pane>
      <el-tab-pane label="已发运单列表" name="B" lazy>
        <assign-no-table />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AssignTable from './components/assign-table/index'
import AssignNoTable from './components/assign-no-table/index'
export default {
  name: 'carrier-weight-weightRecord',
  components: { AssignTable, AssignNoTable },
  data() {
    return { active: 'A' }
  },
  methods: {},
}
</script>
